import { gsap, ScrollTrigger } from 'gsap/all';
import SplitText from "../__vendor/SplitText.min.js";

gsap.registerPlugin(ScrollTrigger);

const footer = () => {
        const text = new SplitText('.footer > ul li a, .footer > a', { type: "chars" });

        gsap.set(text.chars, {
            opacity: 0,
            y: 30
        });
       
        gsap.set('.footer .footer-logo', {
            opacity: 0,
            y: 30
        });

        const footerTl = gsap.timeline({
            paused: true
        });

        footerTl.to('.footer .footer-logo', {
            y: 0,
            opacity: 1,
        }, 0.1).to(text.chars, {
            y: 0,
            opacity: 1,
            stagger: 0.01
        });

        ScrollTrigger.create({
            scroller:'[data-scroll-container]',
            trigger: '.footer ',
            start: 'top bottom',
            end: 'bottom top',
            animation: footerTl,
            toggleActions: 'play none none none',
        });
};

export default footer;
